import * as $ from 'jquery';

class RuntimeNode {
    static staticName = "runtimeNode";
    eventBroker;
    context;
    progressbarService;

    component;
    frame;
    openIfValue;
    nodeId;
    openIf;
    showProgressBar;
    progressPercent;
    cssClasses = "";
    fadeInDelay = 200;
    fadeOutDelay = 200;

    constructor(eventBroker, context, progressbarService, data, rtFactory) {
        this.eventBroker = eventBroker;
        this.context = context;
        this.progressbarService = progressbarService;

        this.component = null;
        this.frame = null;
        this.openIfValue = true;
        this.nodeId = data.nodeId;
        this.openIf = data.openIf;
        this.showProgressBar = data.showProgressBar || false;
        this.progressPercent = data.progressPercent;
        this.cssClasses = data.cssClasses || "";
        this.fadeInDelay = context.params.fadeInDelay ?? 200;
        this.fadeOutDelay = context.params.fadeOutDelay ?? 200;

        if (data.component) {
            this.component = rtFactory.getComponent(data.component);
            if (this.component.displayType == "all-at-once") {
                this.eventBroker.subscribe("enableNextButtonEvent", function (event) {

                    if (this.component.id == event) {
                        return;
                    }

                    if (!this.frame.containsComponentId(event))
                        return;

                    if (this.frame.allNextButtonsEnabled()) {
                        this.eventBroker.fire("enableNextButtonEvent", this.component.id);
                    }
                    else {
                        this.eventBroker.fire("disableNextButtonEvent", this.component.id);
                    }
                }.bind(this));
            }
        }

        if (data.frame) {
            this.frame = rtFactory.getFrame(data.frame, rtFactory);
        }

        if (this.showProgressBar) {
            this.progressbarService.register(this.nodeId);
        }

        this.hookup();
    }

    getDiv() {
        return $("#node_id_" + this.nodeId);
    }

    getRuntimeView() {
        if (true) {
            var $node = $(`<div id='node_id_${this.nodeId}' class='${this.cssClasses}'></div>`);
        } else {
            var $node = $(`<div id='node_id_${this.nodeId}' class='border m-1'></div>`);
            $node.append(`<label>${this.nodeId}</label>`);
        }

        if (this.component) {
            if (true) {
                var $component = $(`<div id='component_id_${this.component.id}' class='sid-question-container sid-component_type_${this.component.type}'></div>`);
            } else {
                var $component = $(`<div class='border m-1'></div>`);
                $component.append(`<label>${this.component.id}</label>`);
            }

            $component.append(this.component.getRuntimeView(this.context));
            $node.append($component);
        }

        if (this.frame) {
            $node.append(this.frame.getRuntimeView());
        }

        $node.hide();

        return $node;
    }

    show() {
        if (this.component && this.component.getGotoNode) {
            this.eventBroker.fire("gotoNodeEvent", this.component.getGotoNode());
            return false;
        }

        this.getDiv().fadeIn(+this.fadeInDelay, () => {
            this.eventBroker.fire("nodeShownEvent", this.nodeId);
        });
        return true;
    }

    hide(afterHide) {
        this.getDiv().fadeOut(+this.fadeOutDelay, afterHide);
    }

    presentNode(spinner) {
        if (this.component)
            this.eventBroker.fire("showingNodeEvent", this.component.id);

        if (spinner) {
            let continuePresent = this.showWithSpinner();
            if (!continuePresent) return;
        } else {
            let continuePresent = this.show();
            if (!continuePresent) return;
        }

        if (this.frame) {
            this.frame.presentFrame();
        } else {

            this.notifyNextButton();

            this.eventBroker.fire("showProgressBar", {
                nodeId: this.nodeId,
                showProgressBar: this.showProgressBar,
                progressPercent: this.progressPercent
            });
        }

        if (this.component) {
            if (this.component.onNodeShown)
                this.component.onNodeShown(this.nodeId);
            return this.component.id;
        }
    }

    notifyNextButton() {
        let buttontext = "Next";
        if (this.component.getNextButtonText)
            buttontext = this.component.getNextButtonText();

        let nextButtonEnabled = this.component && this.component.nextButtonEnabled;

        if (this.frame && this.frame.displayType == "all-at-once") {
            nextButtonEnabled = this.frame.allNextButtonsEnabled()
        }

        let hasNextButton = true;

        if (this.component && this.component.hasNextButton == false)
            hasNextButton = false;

        this.eventBroker.fire("showNextButtonEvent", {
            buttontext: buttontext,
            nodeId: this.nodeId,
            nextButtonEnabled: nextButtonEnabled,
            hasNextButton: hasNextButton
        });
    }

    unPresentNode(afterHide) {
        this.hide(afterHide);
    }

    findFirstNode() {
        if (this.frame)
            return this.frame.findFirstNode();
        return null;
    }

    findNextNode(currentNodeId) {
        if (this.frame) {
            return this.frame.findNextNode(currentNodeId);
        }
        return null;
    }

    openConditionIsMet() {
        if (this.component && !this.component.hasRuntimeView)
            return false;
        if (this.openIf == "always")
            return true;
        return this.openIfValue;
    }

    fireValueChanged(nodeId) {
        if (this.component && this.component.getOutput) {
            var outputs = this.component.getOutput();
            for (var outputIndex in outputs) {
                this.eventBroker.fireValueChanged(this.component.id, outputIndex, outputs[outputIndex]);
            }
        }

        if (this.frame)
            this.frame.fireValueChanged(nodeId);
    }

    hookup() {
        this.eventBroker.subscribe("endOfFrameEvent", function (frameId) {
            if (this.frame && this.frame.frameId == frameId)
                this.eventBroker.fire("nexButtonClickedEvent", this.nodeId);
        }.bind(this));

        this.eventBroker.subscribe("valueChangedEvent", function (eventArgs) {
            if (eventArgs.key == this.openIf)
                this.openIfValue = eventArgs.value;
        }.bind(this));

        this.eventBroker.subscribe("gotoNodeEvent", function (eventArgs) {
            if (this.component && eventArgs == this.component.id) {
                this.presentNode();
            }
        }.bind(this));
    }

    setLanguage(texts) {
        if (this.component && this.component.setLangTexts) {
            this.component.setLangTexts(texts[this.component.id]);
        }
        if (this.frame) {
            this.frame.setLanguage(texts)
        }
    }
}

export { RuntimeNode }